<template>
    <swiper class="swiper" v-if="apps.length" :options="swiperOptions">
        <swiper-slide v-for="app in apps" :key="app.id">
            <router-link
                :to="`/app/${app.type}/${app.trackid}`"
                tag="div" class="app"
            >
                <div class="app__icon" :style="{'background-image': `url(${app.image})`}"></div>
                <div class="app__info">
                    <span class="app__name">{{ app.name }}</span>
                    <span class="app__lead">{{ app.lead }}</span>
                </div>
            </router-link>
        </swiper-slide>
        <div class="pagination" slot="pagination"></div>
    </swiper>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      swiperOptions: {
        pagination: {
          el: '.pagination',
          bulletActiveClass: 'pagination__bullet_active',
          clickable: true,
          renderBullet(index, className) {
            return `<span class="pagination__bullet ${className}"></span>`;
          },
        },
      },
    };
  },
  computed: {
    apps() {
      return this.$store.getters.promos.content;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/variables.scss';

.swiper {
    margin-bottom: 28px;

    @include notebook {
        margin-bottom: 15px;
    }
}

.app {
    display: flex;
    padding: 8px 12px;
    border-radius: 10px;
    background: linear-gradient(70.93deg, #ceb7f92b 0%, var(--bg) 100%);
    cursor: pointer;
    color: var(--text-primary);

    @include notebook {
      padding: 10px;
    }

    &__icon {
        flex: 0 0 100px;
        width: 100px;
        height: 100px;
        background-size: cover;
        background-position: center;
        border-radius: 22.5%;
        mask: url(../assets/ios-mask.svg) center/100% 100% no-repeat;
        margin-right: 15px;
    }

    &__name {
        display: block;
        margin-top: 3px;
        font-size: 16px;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 20px;
    }

    &__lead {
        line-height: 20px;
    }
}

.pagination {
    margin-top: 8px;
    text-align: center;

    &::v-deep &__bullet {
        display: inline-block;
        width: 12px;
        height: 12px;
        margin: 0 4px;
        border-radius: 100%;
        background-color: rgba(112,128,144,0.3);
        opacity: 1;

        &:focus {
            outline: none;
        }

        &_active {
            background-color: $text-secondary;
        }
    }
}
</style>
